import axios from 'axios';
import Errors from './Errors';

export default {
  data() {
    return {
      baseUrl: '',
      userId: null,
    };
  },
  async getActivitiesForEntity(id) {
    try {
      const { data } = await axios.get(`${this.baseUrl}Entities/${id}/Activities`);
      return [null, data];
    } catch (error) {
      Errors.onError(error);
      return [error];
    }
  },
  async getEntity(id) {
    try {
      const { data } = await axios.get(`${this.baseUrl}Entities/${id}`);
      return [null, data];
    } catch (error) {
      Errors.onError(error);
      return [error];
    }
  },
  async getEntities() {
    try {
      const { data } = await axios.get(`${this.baseUrl}Entities`, {
        headers: {
          'User-Id': this.userId,
        },
      });
      return [null, data];
    } catch (error) {
      Errors.onError(error);
      return [error];
    }
  },
  async getEntitiesForAdministration() {
    try {
      const { data } = await axios.get(`${this.baseUrl}Entities/Administration`);
      return [null, data];
    } catch (error) {
      Errors.onError(error);
      return [error];
    }
  },
  async synchronize(entities) {
    try {
      const data = await axios.put(`${this.baseUrl}Entities/Synchronize`, entities, {
        headers: {
          'Content-Type': 'application/json',
          'User-Id': this.userId,
        },
      });

      return data;
    } catch (error) {
      Errors.onError(error);
      return [error];
    }
  },
};
